// extracted by mini-css-extract-plugin
export var shake = "_8-0";